import { useFormContext } from 'react-hook-form';

import { FormInputTextProps } from 'features/common/components/Form/types';
import { InputToggle } from '../InputToggle/InputToggle';
import { Error } from 'features/common/components/Form/Form.styles';

import { InputContainer, TextArea } from './TextInput.styles';

export const TextInput = ({
	id,
	name,
	label,
	isPunchup = false,
	...rest
}: FormInputTextProps & { isPunchup?: boolean }) => {
	const {
		setValue,
		watch,
		formState: { errors },
	} = useFormContext();
	const error = errors[name];

	return (
		<InputContainer hasError={Boolean(error)} isPunchup={isPunchup}>
			<InputToggle htmlFor={id ?? name} label={label} name={`${name}Enabled`} isPunchup={isPunchup} />
			<TextArea
				id={id ?? name}
				value={watch(name)}
				onChange={(e) => setValue(name, e.target.value)}
				{...rest}
				isPunchup={isPunchup}
			/>
			<Error>{error?.message}</Error>
		</InputContainer>
	);
};
